import { Box, Typography } from "@mui/material";
import UploadButton from "../general/buttons/UploadButton";
import { SyncSongDTO } from "../../services/sync";
import { colors } from "../../theme";

/**
 * A row inside a sync preview. Separate from SongRow because these songs aren't in
 * the playlist yet (or are on their way out of it), so the per-song state dropdown
 * doesn't apply - what they need is a tick to include or exclude them from commit.
 */
export default function PreviewSongRow(props: {
    index: number;
    song: SyncSongDTO;
    checked: boolean;
    onToggle: () => void;
}) {
    const { index, song, checked, onToggle } = props;

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "24px 40px minmax(0, 3fr) minmax(0, 2fr) 48px",
                alignItems: "center",
                gap: 2,
                px: 2,
                py: 1,
                borderRadius: 1,
                transition: "background-color 120ms ease",
                "&:hover": { backgroundColor: colors.elevatedHover },
            }}
        >
            <Typography sx={{ color: colors.textMuted, fontSize: 14, textAlign: "right" }}>
                {index + 1}
            </Typography>

            <Box
                component="img"
                src={song.imageUrl || "/assets/artist_example.png"}
                onError={e => { e.currentTarget.src = "/assets/artist_example.png"; }}
                alt=""
                sx={{ width: 44, height: 44, borderRadius: 1, objectFit: "cover" }}
            />

            <Typography noWrap title={song.title} sx={{ fontSize: 15, fontWeight: 600 }}>
                {song.title}
            </Typography>

            <Typography noWrap title={song.artist} sx={{ fontSize: 14, color: colors.textSecondary }}>
                {song.artist}
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <UploadButton onClick={onToggle} clicked={checked} />
            </Box>
        </Box>
    );
}
